export default {
    /** settings **/
    theme: state => state.settings.theme,

    /** themes **/
    themes: state => state.themes.themes,
    lastTheme: state => state.themes.themes[state.themes.themes.length - 1],
    current: state => state.themes.current,
    current_task: state => state.themes.current_task,
    lastTask: state => state.themes.themes[state.themes.themes.length - 1] && state.themes.themes[state.themes.themes.length - 1].tasks[state.themes.themes[state.themes.themes.length - 1].tasks.length - 1],
    last_subs: state => {
        const all_subs = []
        state.themes.themes.forEach(theme => {            
            theme.tasks.forEach(task => {
                const subs = task.subs
                // subs.forEach(el => {
                //     el.parent_route = `/theme/${theme.route_name}/${task.route_name}`
                //     el.parent_name = `${theme.name} > ${task.name}`
                // })
                all_subs.push(...subs.filter(el => el.updatedAt))
            })
        })
        return all_subs.sort((a,b) => +new Date(a.updatedAt) < +new Date(b.updatedAt) ? 1 : -1)
    },
    orderThemes: state => state.user.themesOrder,
    learned: state => state.user.profile.learned,
    orderCurrentTasks: state => state.themes.current && state.themes.current.taskOrder,
    current_relevant_notices: state => state.themes.current_relevant_notices,
    picked_sub: state => state.themes.picked_sub,
    relevant_element: state => state.themes.relevant_element,
    
    /** themes **/
    feeds: state => state.feeds.feeds,
    current_feed: state => state.feeds.current_feed,
    last_notices: state => {
        const all_notices = []
        state.feeds.feeds.forEach(feed => {
            const notices = feed.notices
            // notices.forEach(el => {
            //     el.parent_route = `/feeds/${feed.route_name}`
            //     el.parent_name = feed.name
            // })            
            all_notices.push(...notices)
        })
        return all_notices.sort((a,b) => +new Date(a.updatedAt) < +new Date(b.updatedAt) ? 1 : -1)
    }, 
    orderFeeds: state => state.user.feedsOrder,
    picked_notice: state => state.feeds.picked_notice,
    
    /** popup */
    popup: state => state.popup.component,
    drawer: state => state.popup.drawer,
    
    /** errors */
    error: state => state.errors.flag,
    error_message: state => state.errors.message,

    /** user **/
    user: state => state.user.name,
}